import lhImg from "../../assets/Netraa_AI_OPS_Assistant_Presentation_Deck__3_-removebg-preview (1).png"
import earthImg from "../../assets/earth.png"

export function rendernetraaLH () {
    return (
    <div className="transition-opacity duration-300">
        {/* Main Content */}
        <main className="flex-1 hide-scrollbar overflow-y-auto scroll-smooth">
          <div className="mx-auto px-6 py-8 pb-20">
            {/* Breadcrumbs */}
            <div className="flex flex-wrap items-center gap-2 mb-6 text-sm">
              <a className="text-slate-500 dark:text-[#90a9cb] hover:text-primary transition-colors" href="#">Platform</a>
              <span className="text-slate-400 dark:text-slate-600">/</span>
              <a className="text-slate-500 dark:text-[#90a9cb] hover:text-primary transition-colors" href="#">Netraa LH</a>
              <span className="text-slate-400 dark:text-slate-600">/</span>
              <span className="text-primary font-medium">Introduction</span>
            </div>

          
{/* Cinematic Hero */}
<section
  className="relative rounded-2xl mb-12 group overflow-hidden"
  id="hero"
>

  {/* Background overlay */}
  <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-black/80 z-10" />

  {/* Image */}
  <img
    alt="Abstract digital network visualization representing global connectivity"
    src={earthImg}
    className="
      w-full
      h-[24rem] sm:h-[28rem] md:h-[32rem]
      object-cover object-center
      transform scale-105 group-hover:scale-110
      transition-transform duration-700 ease-out
    "
  />

  {/* CONTENT WRAPPER (IMPORTANT FIX) */}
  <div className="
    absolute inset-0 z-20
    flex flex-col
    justify-start md:justify-center
    px-4 sm:px-6 md:px-12
    py-6 md:py-0
    overflow-y-auto
  ">

    {/* Top row */}
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 mb-6">

      <span className="
        px-3 py-1 rounded-full
        bg-primary/20 backdrop-blur-sm
        border border-primary/30
        text-white text-xs font-semibold
        uppercase tracking-wider
        w-fit
      ">
        The Digital Sentinel
      </span>

      <button
        onClick={() => window.location.href = "https://cliqtest.com/book-a-demo"}
        className="
          sm:ml-auto
          px-5 py-2 sm:px-8 sm:py-3
          bg-gradient-to-r from-orange-500 to-red-500
          text-white rounded-lg font-bold
          shadow-lg shadow-orange-500/30
          hover:shadow-orange-500/50
          transition-all
          w-fit
        "
      >
        Book Demo
      </button>

    </div>

    {/* Title */}
    <h1 className="
      text-3xl sm:text-4xl md:text-5xl
      font-extrabold
      bg-clip-text text-transparent
      bg-gradient-to-r from-[#ff914d] via-[#ff6a3d] to-[#ff3d2e]
      leading-tight
      mb-4
    ">
      Netraa LH:<br />
      <span className="text-white">Proactive Synthetic Intelligence</span>
    </h1>

    {/* Subtitle */}
    <p className="
      text-sm sm:text-base md:text-lg
      text-slate-200
      mb-6
      font-light
    ">
      Before your users click, Netraa LH knows. Simulate complex user journeys,
      detect anomalies, and ensure 99.9% uptime across global touchpoints.
    </p>

    {/* Mini Dashboard */}
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">

      <div className="bg-black/30 backdrop-blur-md rounded-lg p-3 border border-white/10">
        <div className="text-[10px] sm:text-xs text-slate-400 uppercase mb-1">
          Global Uptime
        </div>
        <div className="text-lg sm:text-xl font-bold text-green-400 font-mono">
          99.99%
        </div>
      </div>

      <div className="bg-black/30 backdrop-blur-md rounded-lg p-3 border border-white/10">
        <div className="text-[10px] sm:text-xs text-slate-400 uppercase mb-1">
          Simulations
        </div>
        <div className="text-lg sm:text-xl font-bold text-blue-400 font-mono">
          2.4M/hr
        </div>
      </div>

      <div className="bg-black/30 backdrop-blur-md rounded-lg p-3 border border-white/10 col-span-2">
        <div className="text-[10px] sm:text-xs text-slate-400 uppercase mb-1">
          Avg Latency
        </div>
        <div className="text-lg sm:text-xl font-bold text-white font-mono">
          42ms
        </div>
      </div>

    </div>

  </div>
</section>
            {/* Section 1: What is Synthetic Monitoring? */}
            <section className="mb-12 scroll-mt-24" id="what-is-synthetic">
              <div className="flex flex-col md:flex-row gap-8 items-start">
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-slate-900 dark:text-white font-display mb-4 flex items-center gap-3">
                    <span className="material-symbols-outlined text-primary text-3xl">psychology</span>
                    What is Synthetic Monitoring?
                  </h2>
                  <p className="text-slate-600 dark:text-slate-300 leading-relaxed text-lg">
                    Synthetic monitoring is a proactive approach to application performance monitoring (APM). Instead of waiting for real users to encounter errors, Netraa LH deploys scripted bots—or "synthetic agents"—that simulate user interactions at specific intervals from various locations worldwide.
                  </p>
                  <p className="text-slate-600 dark:text-slate-300 leading-relaxed mt-4">
                    By mimicking behaviors such as logging in, adding items to a cart, or checking out, synthetic monitoring provides a baseline for performance and availability, allowing teams to identify and resolve issues before they impact actual customers.
                  </p>
                </div>
                <div className="w-full md:w-1/3 bg-slate-100 dark:bg-card-dark rounded-xl p-6 border border-slate-200 dark:border-border-dark">
                  <h3 className="text-sm font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-4">Core Benefits</h3>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3 text-sm text-slate-700 dark:text-slate-200">
                      <span className="material-symbols-outlined text-green-500 text-lg">check_circle</span>
                      24/7 Availability Checks
                    </li>
                    <li className="flex items-start gap-3 text-sm text-slate-700 dark:text-slate-200">
                      <span className="material-symbols-outlined text-green-500 text-lg">check_circle</span>
                      Baseline Performance Data
                    </li>
                    <li className="flex items-start gap-3 text-sm text-slate-700 dark:text-slate-200">
                      <span className="material-symbols-outlined text-green-500 text-lg">check_circle</span>
                      Third-party API Monitoring
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Section 2: Where Netraa fits */}
            <section className="mb-16 bg-primary/5 dark:bg-primary/10 rounded-2xl p-8 border border-primary/10 scroll-mt-24" id="netraa-fit">
              <div className="">
                <h2 className="text-2xl font-bold text-slate-900 dark:text-white font-display mb-4">Where Netraa LH Comes into the Picture</h2>
                <p className="text-slate-700 dark:text-slate-200 text-lg mb-6">
                  Netraa LH acts as your <span className="font-bold text-primary">client-first digital sentinel</span>. While traditional monitoring tells you "the server is up," Netraa LH tells you "the user can complete a purchase."
                </p>
                <div className="flex gap-4 flex-wrap">
                  <span className="px-4 py-2 bg-white dark:bg-card-dark rounded-full text-sm font-medium text-slate-700 dark:text-white shadow-sm border border-slate-200 dark:border-border-dark flex items-center gap-2">
                    <span className="size-2 rounded-full bg-blue-500" /> Proactive
                  </span>
                  <span className="px-4 py-2 bg-white dark:bg-card-dark rounded-full text-sm font-medium text-slate-700 dark:text-white shadow-sm border border-slate-200 dark:border-border-dark flex items-center gap-2">
                    <span className="size-2 rounded-full bg-purple-500" /> Global
                  </span>
                  <span className="px-4 py-2 bg-white dark:bg-card-dark rounded-full text-sm font-medium text-slate-700 dark:text-white shadow-sm border border-slate-200 dark:border-border-dark flex items-center gap-2">
                    <span className="size-2 rounded-full bg-orange-500" /> Intelligent
                  </span>
                </div>
              </div>
            </section>

            {/* Section 3: Workflow Journey */}
<section className="mb-16 scroll-mt-24" id="working-model">
  <h2 className="text-2xl font-bold text-slate-900 dark:text-white font-display mb-8">
    How Does Netraa LH Work?{" "}
    <span className="text-slate-400 font-normal ml-2 text-lg">(The BFSI Standard)</span>
  </h2>

  {/* Vertical Timeline */}
  <div className="relative flex flex-col gap-6">
    {/* Vertical line */}
    <div className="absolute left-[1.1rem] top-4 bottom-4 w-[2px] bg-slate-200 dark:bg-slate-700 z-0"></div>

    {/* Step 1 */}
    <div className="relative flex items-start gap-6 z-10">
      <div className="shrink-0 size-9 rounded-full bg-orange-500 flex items-center justify-center text-white text-sm font-bold shadow-md">1</div>
      <div className="flex-1 bg-white dark:bg-card-dark p-5 rounded-xl border border-slate-200 dark:border-border-dark hover:border-primary/50 transition-all group flex items-center gap-4">
        <div className="size-10 rounded-lg bg-blue-50 dark:bg-blue-900/30 flex items-center justify-center text-primary shrink-0 group-hover:scale-110 transition-transform">
          <span className="material-symbols-outlined">fingerprint</span>
        </div>
        <div>
          <h4 className="font-bold text-slate-900 dark:text-white mb-1">1. Identification</h4>
          <p className="text-sm text-slate-500 dark:text-slate-400">Identify critical business transactions &amp; user paths.</p>
        </div>
      </div>
    </div>

    {/* Step 2 */}
    <div className="relative flex items-start gap-6 z-10">
      <div className="shrink-0 size-9 rounded-full bg-purple-500 flex items-center justify-center text-white text-sm font-bold shadow-md">2</div>
      <div className="flex-1 bg-white dark:bg-card-dark p-5 rounded-xl border border-slate-200 dark:border-border-dark hover:border-primary/50 transition-all group flex items-center gap-4">
        <div className="size-10 rounded-lg bg-indigo-50 dark:bg-indigo-900/30 flex items-center justify-center text-indigo-500 shrink-0 group-hover:scale-110 transition-transform">
          <span className="material-symbols-outlined">code</span>
        </div>
        <div>
          <h4 className="font-bold text-slate-900 dark:text-white mb-1">2. Simulation</h4>
          <p className="text-sm text-slate-500 dark:text-slate-400">Script interactions (Login → Cart → Pay).</p>
        </div>
      </div>
    </div>

    {/* Step 3 */}
    <div className="relative flex items-start gap-6 z-10">
      <div className="shrink-0 size-9 rounded-full bg-green-500 flex items-center justify-center text-white text-sm font-bold shadow-md">3</div>
      <div className="flex-1 bg-white dark:bg-card-dark p-5 rounded-xl border border-slate-200 dark:border-border-dark hover:border-primary/50 transition-all group flex items-center gap-4">
        <div className="size-10 rounded-lg bg-purple-50 dark:bg-purple-900/30 flex items-center justify-center text-purple-500 shrink-0 group-hover:scale-110 transition-transform">
          <span className="material-symbols-outlined">public</span>
        </div>
        <div>
          <h4 className="font-bold text-slate-900 dark:text-white mb-1">3. Global Execution</h4>
          <p className="text-sm text-slate-500 dark:text-slate-400">Run from 25+ global nodes every 1-5 mins.</p>
        </div>
      </div>
    </div>

    {/* Step 4 */}
    <div className="relative flex items-start gap-6 z-10">
      <div className="shrink-0 size-9 rounded-full bg-blue-500 flex items-center justify-center text-white text-sm font-bold shadow-md">4</div>
      <div className="flex-1 bg-white dark:bg-card-dark p-5 rounded-xl border border-slate-200 dark:border-border-dark hover:border-primary/50 transition-all group flex items-center gap-4">
        <div className="size-10 rounded-lg bg-teal-50 dark:bg-teal-900/30 flex items-center justify-center text-teal-500 shrink-0 group-hover:scale-110 transition-transform">
          <span className="material-symbols-outlined">bar_chart</span>
        </div>
        <div>
          <h4 className="font-bold text-slate-900 dark:text-white mb-1">4. Measurement</h4>
          <p className="text-sm text-slate-500 dark:text-slate-400">Capture latency, screenshots &amp; HAR files.</p>
        </div>
      </div>
    </div>

    {/* Step 5 */}
    <div className="relative flex items-start gap-6 z-10">
      <div className="shrink-0 size-9 rounded-full bg-orange-400 flex items-center justify-center text-white text-sm font-bold shadow-md">5</div>
      <div className="flex-1 bg-white dark:bg-card-dark p-5 rounded-xl border border-slate-200 dark:border-border-dark hover:border-primary/50 transition-all group flex items-center gap-4">
        <div className="size-10 rounded-lg bg-orange-50 dark:bg-orange-900/30 flex items-center justify-center text-orange-500 shrink-0 group-hover:scale-110 transition-transform">
          <span className="material-symbols-outlined">radar</span>
        </div>
        <div>
          <h4 className="font-bold text-slate-900 dark:text-white mb-1">5. Detection</h4>
          <p className="text-sm text-slate-500 dark:text-slate-400">Compare against baselines to spot anomalies.</p>
        </div>
      </div>
    </div>

    {/* Step 6 */}
    <div className="relative flex items-start gap-6 z-10">
      <div className="shrink-0 size-9 rounded-full bg-red-500 flex items-center justify-center text-white text-sm font-bold shadow-md">6</div>
      <div className="flex-1 bg-white dark:bg-card-dark p-5 rounded-xl border border-slate-200 dark:border-border-dark hover:border-primary/50 transition-all group flex items-center gap-4">
        <div className="size-10 rounded-lg bg-red-50 dark:bg-red-900/30 flex items-center justify-center text-red-500 shrink-0 group-hover:scale-110 transition-transform">
          <span className="material-symbols-outlined">notification_important</span>
        </div>
        <div>
          <h4 className="font-bold text-slate-900 dark:text-white mb-1">6. Alerting</h4>
          <p className="text-sm text-slate-500 dark:text-slate-400">Instant notification via Slack, PagerDuty, Email.</p>
        </div>
      </div>
    </div>

    {/* Step 7 */}
    <div className="relative flex items-start gap-6 z-10">
      <div className="shrink-0 size-9 rounded-full bg-green-600 flex items-center justify-center text-white text-sm font-bold shadow-md">7</div>
      <div className="flex-1 bg-white dark:bg-card-dark p-5 rounded-xl border border-slate-200 dark:border-border-dark hover:border-primary/50 transition-all group flex items-center gap-4">
        <div className="size-10 rounded-lg bg-green-50 dark:bg-green-900/30 flex items-center justify-center text-green-500 shrink-0 group-hover:scale-110 transition-transform">
          <span className="material-symbols-outlined">auto_graph</span>
        </div>
        <div>
          <h4 className="font-bold text-slate-900 dark:text-white mb-1">7. Optimization</h4>
          <p className="text-sm text-slate-500 dark:text-slate-400">Use data to optimize CDNs, databases, and frontend code.</p>
        </div>
      </div>
    </div>

  </div>
</section>

            {/* Section 4: Types of Monitoring */}
            <section className="mb-16 scroll-mt-24" id="monitoring-types">
              <h2 className="text-2xl font-bold text-slate-900 dark:text-white font-display mb-8">Types of Netraa LH Monitoring</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                {/* Card 1 */}
                <div className="bg-white dark:bg-card-dark p-6 rounded-xl border border-slate-200 dark:border-border-dark hover:shadow-lg transition-shadow">
                  <div className="flex items-center justify-between mb-4">
                    <span className="material-symbols-outlined text-3xl text-primary">web</span>
                    <span className="text-xs font-bold text-slate-400 uppercase">Core</span>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">Browser Monitoring</h3>
                  <p className="text-sm text-slate-500 dark:text-slate-400">Full page load analysis, checking DOM elements and visual regressions.</p>
                </div>
                {/* Card 2 */}
                <div className="bg-white dark:bg-card-dark p-6 rounded-xl border border-slate-200 dark:border-border-dark hover:shadow-lg transition-shadow">
                  <div className="flex items-center justify-between mb-4">
                    <span className="material-symbols-outlined text-3xl text-purple-500">api</span>
                    <span className="text-xs font-bold text-slate-400 uppercase">Backend</span>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">API Monitoring</h3>
                  <p className="text-sm text-slate-500 dark:text-slate-400">Check uptime and response correctness for REST, GraphQL, and SOAP endpoints.</p>
                </div>
                {/* Card 3 */}
                <div className="bg-white dark:bg-card-dark p-6 rounded-xl border border-slate-200 dark:border-border-dark hover:shadow-lg transition-shadow">
                  <div className="flex items-center justify-between mb-4">
                    <span className="material-symbols-outlined text-3xl text-orange-500">router</span>
                    <span className="text-xs font-bold text-slate-400 uppercase">Infra</span>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">Network Monitoring</h3>
                  <p className="text-sm text-slate-500 dark:text-slate-400">DNS resolution, TCP connectivity, and traceroute diagnostics.</p>
                </div>
                {/* Card 4 */}
                <div className="bg-white dark:bg-card-dark p-6 rounded-xl border border-slate-200 dark:border-border-dark hover:shadow-lg transition-shadow">
                  <div className="flex items-center justify-between mb-4">
                    <span className="material-symbols-outlined text-3xl text-pink-500">smartphone</span>
                    <span className="text-xs font-bold text-slate-400 uppercase">Device</span>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">Mobile Web</h3>
                  <p className="text-sm text-slate-500 dark:text-slate-400">Simulate viewport constraints and network throttling (3G/4G).</p>
                </div>
                {/* Card 5 */}
                <div className="bg-white dark:bg-card-dark p-6 rounded-xl border border-slate-200 dark:border-border-dark hover:shadow-lg transition-shadow sm:col-span-2 lg:col-span-2">
                  <div className="flex items-center justify-between mb-4">
                    <span className="material-symbols-outlined text-3xl text-green-500">receipt_long</span>
                    <span className="text-xs font-bold text-slate-400 uppercase">Advanced</span>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-2">Multi-Step Transaction</h3>
                  <p className="text-sm text-slate-500 dark:text-slate-400">Complex flows requiring session handling, such as "Add to Cart" -&gt; "Checkout" -&gt; "Payment Gateway".</p>
                </div>
              </div>
            </section>

           {/* Section 5: Value Proposition Table */}
<section className="mb-16 scroll-mt-24" id="value-prop">
  <h2 className="mb-6 text-2xl font-bold font-display text-slate-900 dark:text-white">
    The Value Proposition
  </h2>

  <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white dark:border-border-dark dark:bg-card-dark">
    <table className="min-w-[700px] w-full text-left text-sm">
      <thead className="bg-slate-50 dark:bg-border-dark/50 dark:bg-black text-slate-900 dark:text-white font-display">
        <tr>
          <th className="px-6 py-4 font-semibold">Feature</th>
          <th className="px-6 py-4 font-semibold">Traditional Monitoring</th>
          <th className="px-6 py-4 font-semibold text-primary">Netraa LH Impact</th>
        </tr>
      </thead>

      <tbody className="divide-y divide-slate-200 text-slate-600 dark:divide-border-dark dark:text-slate-300">
        <tr>
          <td className="px-6 py-4 font-medium text-slate-900 dark:text-white">Issue Detection</td>
          <td className="px-6 py-4">Reactive (After user complaint)</td>
          <td className="px-6 py-4 font-medium text-green-600 dark:text-green-400">
            Proactive (Before traffic hits)
          </td>
        </tr>

        <tr>
          <td className="px-6 py-4 font-medium text-slate-900 dark:text-white">Visibility</td>
          <td className="px-6 py-4">Server-side metrics only</td>
          <td className="px-6 py-4 font-medium text-green-600 dark:text-green-400">
            End-to-end User Experience
          </td>
        </tr>

        <tr>
          <td className="px-6 py-4 font-medium text-slate-900 dark:text-white">Performance Data</td>
          <td className="px-6 py-4">Variable based on real traffic</td>
          <td className="px-6 py-4 font-medium text-green-600 dark:text-green-400">
            Consistent Baselines (24/7)
          </td>
        </tr>

        <tr>
          <td className="px-6 py-4 font-medium text-slate-900 dark:text-white">Geography</td>
          <td className="px-6 py-4">Limited to server location</td>
          <td className="px-6 py-4 font-medium text-green-600 dark:text-green-400">
            25+ Global Points of Presence
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

            {/* Section 6: Use Cases */}
            <section className="mb-16">
              <h2 className="text-2xl font-bold text-slate-900 dark:text-white font-display mb-6">Real-World Use Cases</h2>
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-slate-100 dark:bg-card-dark border border-slate-200 dark:border-border-dark">
                  <span className="material-symbols-outlined text-blue-500">trending_up</span>
                  <span className="font-medium text-slate-700 dark:text-white">Trading Platforms</span>
                </div>
                <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-slate-100 dark:bg-card-dark border border-slate-200 dark:border-border-dark">
                  <span className="material-symbols-outlined text-green-500">shopping_cart</span>
                  <span className="font-medium text-slate-700 dark:text-white">E-Commerce</span>
                </div>
                <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-slate-100 dark:bg-card-dark border border-slate-200 dark:border-border-dark">
                  <span className="material-symbols-outlined text-red-500">medical_services</span>
                  <span className="font-medium text-slate-700 dark:text-white">Healthcare</span>
                </div>
                <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-slate-100 dark:bg-card-dark border border-slate-200 dark:border-border-dark">
                  <span className="material-symbols-outlined text-purple-500">security</span>
                  <span className="font-medium text-slate-700 dark:text-white">Insurance</span>
                </div>
                <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-slate-100 dark:bg-card-dark border border-slate-200 dark:border-border-dark">
                  <span className="material-symbols-outlined text-orange-500">account_balance</span>
                  <span className="font-medium text-slate-700 dark:text-white">Government</span>
                </div>
              </div>
            </section>

            {/* Section 7: Accessing Application */}
            <section className="scroll-mt-24" id="login-access">
              <h2 className="text-2xl font-bold text-slate-900 dark:text-white font-display mb-6">Accessing Netraa LH</h2>
              <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-xl p-8 text-white relative overflow-hidden">
  <div className="absolute top-0 right-0 p-32 bg-primary opacity-10 blur-3xl rounded-full translate-x-1/2 -translate-y-1/2 pointer-events-none" />
  
  <div className="flex flex-col md:flex-row gap-1 items-center">
    
    {/* Text Section */}
    <div className="flex-[2] space-y-6"> {/* increased flex to occupy more space */}
      <div className="flex items-center gap-4">
        <div className="size-8 rounded-full bg-primary flex items-center justify-center font-bold text-white">1</div>
        <div>
          <p className="font-semibold">Navigate to Portal</p>
          <p className="text-slate-400 text-sm">
            Go to <code className="bg-slate-700 px-2 py-0.5 rounded text-primary-200">portal.netraa.io</code>
          </p>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <div className="size-8 rounded-full bg-slate-700 flex items-center justify-center font-bold text-white">2</div>
        <div>
          <p className="font-semibold">SSO Login</p>
          <p className="text-slate-400 text-sm">Use your corporate credentials.</p>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <div className="size-8 rounded-full bg-slate-700 flex items-center justify-center font-bold text-white">3</div>
        <div>
          <p className="font-semibold">Select Module</p>
          <p className="text-slate-400 text-sm">Click on the "Netraa LH" card.</p>
        </div>
      </div>
    </div>

    {/* Image Section */}
    <div className="flex-1 flex flex-col items-center justify-center "> {/* reduced flex to shrink image slightly */}
      <img
        src={lhImg}
        alt="Floating Orb"
        className="w-auto h-auto object-contain"
      />
    </div>

  </div>
</div>
            </section>
          </div>
        </main>
      </div>
);
}